import { SubLayout } from "@/containers/layout/LandingLayout";
import Image from "next/image";
import Link from "next/link";

import routes from "@/constants/routes";
import { footerLinks } from "@/components/landing-old/Footer/utils";

export const Footer = () => {
  const KeyzyLogo = ({ className }: { className: string }) => (
    <footer
      data-nosnippet
      className={`${className} flex flex-col text-center md:text-left justify-center md:flex-col xl:justify-start md:justify-center md:items-start`}
    >
      <Image
        src="/shared/keyzy-horizontal-white.svg"
        width="112"
        height="38"
        alt="Kezyzy footer logo"
      />
      <div className="order-1 md:w-[10rem] lg:w-[25rem]">
        <p className="text-xs text-grey-300 text-left mb-2 md:w-[47rem] lg:w-full xl:w-[23rem] mt-4 xl:mt-0 ">
          Keyzy is a trading name of Kollitom Ltd, a company registered in England and Wales
          (Company No. 13075506) with its office at LABS Atrium, Chalk Farm Rd, London, NW1 8AH.
        </p>
        <p className="text-xs text-grey-300 text-left md:w-[47rem] lg:w-full xl:w-[23rem]">
          Our rent-to-own offering is not regulated as a financial service – being a generous landlord who gives back your rent does not fall within the scope of the Financial Conduct Authority
        </p>
      </div>
      <div className="mt-3 text-xs xl:ml-0 xl:mt-3 md:order-none xl:order-last">
        &copy;{`${new Date().getFullYear()} Keyzy`}
      </div>
    </footer>
  );

  const FooterButtons = ({ className }: { className: string }) => (
    <div className={`${className} flex flex-col md:flex-row xl:flex-col`}>
      <Link href={routes.register}>
        <a className="w-full flex items-center justify-center h-12 mx-auto text-base font-bold text-center text-white transition duration-300 ease-in-out transform border rounded shadow whitespace-nowrap md:w-64 bg-landing-blue border-landing-blue hover:scale-105">
          Register
        </a>
      </Link>

      <Link href={routes.contact}>
        <a className="w-full flex justify-center items-center whitespace-nowrap mt-[1.375rem] text-base transition duration-300 ease-in-out transform font-bold md:w-64 text-center bg-white border rounded shadow md:ml-8 h-12 xl:mt-3 md:mt-0 xl:ml-0 border-landing-blue text-landing-blue hover:scale-105 ">
          Contact Us
        </a>
      </Link>

      <div className="w-full flex flex-wrap justify-center gap-2 mt-3 md:mt-1 xl:mt-5 md:order-first">
        <a href="https://www.instagram.com/keyzy_homes/" target="_blank" rel="noreferrer">
          <button className="bg-grey-500 p-2 font-semibold text-white inline-flex items-center space-x-2 rounded-full hover:scale-105 transition duration-300 ease-in-out transform">
            <svg
              width="20"
              height="20"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 1.62165C11.4031 1.62165 11.6877 1.6308 12.6367 1.6741C13.5142 1.71415 13.9908 1.86077 14.3079 1.98398C14.728 2.1472 15.0278 2.3423 15.3428 2.6572C15.6577 2.9722 15.8528 3.272 16.016 3.6921C16.1392 4.0092 16.2859 4.4858 16.3259 5.3632C16.3692 6.3123 16.3783 6.5969 16.3783 9C16.3783 11.4031 16.3692 11.6878 16.3259 12.6368C16.2859 13.5143 16.1392 13.9908 16.016 14.308C15.8528 14.728 15.6577 15.0279 15.3428 15.3428C15.0278 15.6577 14.728 15.8528 14.3079 16.016C13.9908 16.1393 13.5142 16.2859 12.6367 16.3259C11.6879 16.3692 11.4032 16.3784 9 16.3784C6.5967 16.3784 6.3121 16.3692 5.3632 16.3259C4.4857 16.2859 4.0092 16.1393 3.6921 16.016C3.272 15.8528 2.9721 15.6577 2.6572 15.3428C2.3423 15.0279 2.1472 14.728 1.98398 14.308C1.86073 13.9908 1.71411 13.5143 1.67406 12.6368C1.63076 11.6878 1.62162 11.4031 1.62162 9C1.62162 6.5969 1.63076 6.3123 1.67406 5.3633C1.71411 4.4858 1.86073 4.0092 1.98398 3.6921C2.1472 3.272 2.3423 2.9722 2.6572 2.6572C2.9721 2.3423 3.272 2.1472 3.6921 1.98398C4.0092 1.86077 4.4857 1.71415 5.3632 1.6741C6.3122 1.6308 6.5969 1.62165 9 1.62165ZM9 0C6.5557 0 6.2493 0.0103601 5.2893 0.0541601C4.3313 0.0978901 3.6771 0.25001 3.1046 0.47251C2.5128 0.70251 2.0109 1.01025 1.51055 1.51058C1.01021 2.0109 0.70247 2.5128 0.47247 3.1047C0.24997 3.6772 0.0978501 4.3314 0.0541201 5.2893C0.0103201 6.2493 0 6.5557 0 9C0 11.4443 0.0103201 11.7508 0.0541201 12.7107C0.0978501 13.6687 0.24997 14.3229 0.47247 14.8954C0.70247 15.4872 1.01021 15.9891 1.51055 16.4895C2.0109 16.9898 2.5128 17.2975 3.1046 17.5275C3.6771 17.75 4.3313 17.9021 5.2893 17.9459C6.2493 17.9897 6.5557 18 9 18C11.4443 18 11.7507 17.9897 12.7107 17.9459C13.6686 17.9021 14.3228 17.75 14.8953 17.5275C15.4872 17.2975 15.9891 16.9898 16.4894 16.4895C16.9898 15.9891 17.2975 15.4872 17.5275 14.8954C17.75 14.3229 17.9021 13.6687 17.9458 12.7107C17.9896 11.7508 18 11.4443 18 9C18 6.5557 17.9896 6.2493 17.9458 5.2893C17.9021 4.3314 17.75 3.6772 17.5275 3.1047C17.2975 2.5128 16.9898 2.0109 16.4894 1.51058C15.9891 1.01025 15.4872 0.70251 14.8953 0.47251C14.3228 0.25001 13.6686 0.0978901 12.7107 0.0541601C11.7507 0.0103601 11.4443 0 9 0ZM9 4.3784C6.4475 4.3784 4.3783 6.4476 4.3783 9C4.3783 11.5525 6.4475 13.6217 9 13.6217C11.5524 13.6217 13.6216 11.5525 13.6216 9C13.6216 6.4476 11.5524 4.3784 9 4.3784ZM9 12C7.3431 12 6 10.6569 6 9C6 7.3432 7.3431 6 9 6C10.6568 6 12 7.3432 12 9C12 10.6569 10.6568 12 9 12ZM14.8842 4.1958C14.8842 4.7923 14.4007 5.2758 13.8042 5.2758C13.2077 5.2758 12.7242 4.7923 12.7242 4.1958C12.7242 3.5993 13.2077 3.1158 13.8042 3.1158C14.4007 3.1158 14.8842 3.5993 14.8842 4.1958Z"
                fill="white"
              />
            </svg>
          </button>
        </a>

        <a href="https://twitter.com/keyzyhomes" target="_blank" rel="noreferrer">
          <button className="bg-grey-500 p-2 font-semibold text-white inline-flex items-center space-x-2 rounded-full hover:scale-105 transition duration-300 ease-in-out transform">
            <svg
              className="w-5 h-5 fill-current"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path
                d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                fill="white"
              />
            </svg>
          </button>
        </a>

        <a href="https://www.linkedin.com/company/keyzy-homes/" target="_blank" rel="noreferrer">
          <button className="bg-grey-500 p-2 font-semibold text-white inline-flex items-center space-x-2 rounded-full hover:scale-105 transition duration-300 ease-in-out transform">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.252445 6.2764H4.53992V19.2945H0.252445V6.2764ZM2.39735 4.49877H2.36865C0.930124 4.49877 0 3.49852 0 2.24938C0 0.972467 0.958823 0 2.42488 0C3.89152 0 4.79412 0.972467 4.82282 2.24938C4.82282 3.49852 3.89152 4.49877 2.39735 4.49877ZM20 19.295H15.7131V12.3293C15.7131 10.5801 15.0928 9.38593 13.5413 9.38593C12.3569 9.38593 11.6517 10.1911 11.3413 10.9691C11.2283 11.2475 11.2007 11.6353 11.2007 12.0243V19.295H6.91267C6.91267 19.295 6.9689 7.49716 6.91267 6.2764H11.2007V8.11966C11.77 7.23291 12.7892 5.96959 15.0647 5.96959C17.8855 5.96959 20 7.83058 20 11.8304V19.295Z"
                fill="white"
              />
            </svg>
          </button>
        </a>

        <a href="https://www.facebook.com/keyzyhomes" target="_blank" rel="noreferrer">
          <button className="bg-grey-500 p-2 font-semibold text-white inline-flex items-center space-x-2 rounded-full hover:scale-105 transition duration-300 ease-in-out transform">
            <svg
              className="w-5 h-5 fill-current"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path
                d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
                fill="white"
              />
            </svg>
          </button>
        </a>
      </div>
    </div>
  );

  return (
    <SubLayout>
      <div
        className={`w-full mb-20 md:mb-10 mtx1-3 xl:flex xl:justify-between md:mt-7 xl:mt-16 xl:items-center
      
      `}
      >
        <div className="md:flex md:justify-between md:w-full md:px-5 xl:px-0">
          <KeyzyLogo className="hidden xl:inline-block" />

          <div className="flex flex-wrap w-full sm:flex-nowrap md:justify-between xl:justify-evenly">
            {footerLinks.map((link) => (
              <ul key={link.name} className={`inline-block w-1/2 md:w-auto mt-11 md:mt-0`}>
                <li className="my-4 text-xs font-bold tracking-widest uppercase xl:mt-2">
                  {link.name}
                </li>

                {link.items.map((item, idx) => (
                  <li
                    key={item.name}
                    className={`mt-5 text-sm text-landing-blue ${
                      idx === link.items.length - 1 && ""
                    }`}
                  >
                    <Link href={item.href}>
                      <a
                        className="hover:underline"
                        target={item.href[0] === "/" ? "_self" : "_blank"}
                      >
                        {item.name}
                      </a>
                    </Link>
                  </li>
                ))}
              </ul>
            ))}
          </div>
          <FooterButtons className="hidden xl:inline-block" />
        </div>

        <div className="hidden w-full h-px mt-8 mb-8 bg-grey-200 md:inline-block xl:hidden"></div>

        <div className="flex flex-col md:flex-row md:justify-between md:w-full xl:hidden md:items-start">
          <FooterButtons className="relative w-full mt-12 md:mt-0 xl:left-0" />
          <KeyzyLogo className="mt-10 md:mt-0 md:order-first" />
        </div>
      </div>
    </SubLayout>
  );
};

export default Footer;
